export const getProductPromotions = (productId, promotions = []) => promotions
  .flatMap((promotion) => (promotion.products || [])
    .filter((product) => Number(product.id || product.product_id) === Number(productId))
    .map((product, index) => {
      const rule = product.pivot || product;
      const required = Number(rule.required_qty);
      const paid = Number(rule.paid_qty);
      if (!Number.isInteger(required) || !Number.isInteger(paid) || required < 1 || paid < 1 || paid > required) {
        return null;
      }

      return {
        id: `${promotion.id || promotion.name}-${index}`,
        label: `${required}x${paid}`,
        title: [promotion.name, promotion.description].filter(Boolean).join(' — '),
      };
    }))
  .filter(Boolean);
